import React from "react";
import { View, StyleSheet } from "react-native";
import CustomText from "@components/CustomText";
import InputField from "./components/inputField";

export default function TextInputView(props) {
  const { data } = props;
  return (
    <View style={styles.view}>
      <CustomText variant="heading_24" style={styles.heading}>
        {data?.heading}
      </CustomText>
      <InputField {...props} />
    </View>
  );
}

const styles = StyleSheet.create({
  view: {
    flex: 1,
    backgroundColor: "white",
    paddingHorizontal: 16,
    paddingVertical: 20,
  },
  heading: {
    fontSize: 22,
    lineHeight: 34,
    fontFamily: "NotoSansDevanagari-Bold",
    color: "rgba(0, 0, 0, 0.86)",
  },
});
